import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
} from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Router, UrlSerializer } from '@angular/router';
import { CUSTOM_ICONS } from '@app/core/config/icons.config';
import { getLocaleFactory, getLocaleIdFactory, registerLocales } from '@app/core/config/locale.config';
import { initializeSentry } from '@app/core/config/sentry.config';
import { detectBaseHref } from '@app/core/utilities/url.utilities';
import { RootRoutingModule } from '@app/root-routing.module';
import { RootComponent } from '@app/root.component';
import { environment } from '@env/environment';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import * as Sentry from '@sentry/angular';
import { NZ_DATE_CONFIG, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import { initializeHighcharts } from './app/core/config/highcharts.config';
import { CoreModule } from './app/core/core.module';
import { initializeAppFactory, transformLegacyParamsFactory } from './app/core/factories/initialize-app.factory';
import { User } from './app/core/models/user.models';
import { CustomUrlSerializer } from './app/core/services/custom-url-serializer';
import { HttpLoaderFactory, SharedModule } from './app/shared/shared.module';
import { LocaleService } from '@app/core/services/locale.service';

window.adspert_data = window.adspert_data || {};
window.adspert_data.user = {} as User;

if (environment.production) enableProdMode();

initializeSentry();
initializeHighcharts();
registerLocales();

bootstrapApplication(RootComponent, {
  providers: [
    { provide: APP_BASE_HREF, useFactory: detectBaseHref },
    importProvidersFrom(
      BrowserModule,
      SharedModule,
      CoreModule,
      TranslateModule.forRoot({
        loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] },
        isolate: false,
      }),
      RootRoutingModule,
      NzIconModule,
    ),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => ((_) => () => {})(inject(Sentry.TraceService))()),
    provideAppInitializer(transformLegacyParamsFactory()),
    provideAppInitializer(() => initializeAppFactory(inject(Store), inject(TranslateService), inject(LocaleService))()),
    { provide: NZ_I18N, useFactory: getLocaleFactory, deps: [TranslateService] },
    { provide: LOCALE_ID, useFactory: getLocaleIdFactory, deps: [TranslateService] },
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
    { provide: NZ_ICONS, useValue: CUSTOM_ICONS },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
